import { ConsoleLogger, Environment } from '@bucketplace/jwt-auth';
import { ClientSessionManager } from '@bucketplace/jwt-auth/client';
import { APP_PROFILE } from 'common';

export const sessionManager = new ClientSessionManager({
  env: APP_PROFILE as Environment,
  logger: new ConsoleLogger({ logLevel: APP_PROFILE !== 'prod' ? 'debug' : 'off' }),
});
